import { Component, OnInit } from '@angular/core';
import { HomePageService } from 'src/app/homepage/homepage.service';
import Swal from 'sweetalert2';
import {UpdateServicesService} from './update-services.service';

@Component({
  selector: 'app-update-services',
  templateUrl: './update-services.component.html',
  styleUrls: ['./update-services.component.css']
})
export class UpdateServicesComponent implements OnInit {
  isServicesLoading: boolean;
  serviceHeading: string = '';
  serviceDetails: string = '';

  serviceList: any[] = [];
  selectedServiceId = '';
  selectedServiceTitle = '';
  selectedServiceDetail = '';

  constructor(
    private updateServicesService: UpdateServicesService,
    private homePageService: HomePageService
  ) { }

  ngOnInit(): void {
    this.isServicesLoading = false;
    this.listAllServices();
  }

  onAdd() {
    this.updateServicesService.createServices({
      title: this.serviceHeading,
      description: this.serviceDetails
    }).subscribe(() => {
      Swal.fire('Service added successfully!');
      this.listAllServices();
    })
    this.serviceHeading = '';
    this.serviceDetails = '';
  }

  onDelete(serviceId: string) {
    this.selectedServiceId = serviceId;
  }

  onDeleteConfirm() {
    this.updateServicesService.deleteServices({ Id: this.selectedServiceId }).subscribe(() => {
      Swal.fire('Service deleted successfully!');
      this.listAllServices();
    });
  }

  onUpdate(service: any) {
    this.selectedServiceId = service._id;
    this.selectedServiceTitle = service.title;
    this.selectedServiceDetail = service.description;
  }

  onUpdateConfirm() {
    this.updateServicesService.updateServices({
      Id: this.selectedServiceId,
      title: this.selectedServiceTitle,
      description: this.selectedServiceDetail
    }).subscribe(() => {
      Swal.fire('Service updated successfully!');
      this.listAllServices();
    })
  }

  listAllServices() {
    this.isServicesLoading = true;
    this.homePageService.servicesList().subscribe((data: any) => {
      this.serviceList = data.serviceList;
      this.isServicesLoading = false;
     // console.log(this.serviceList);
    });
  }

}
